import { render, staticRenderFns } from "./TamanhoVal.vue?vue&type=template&id=72a4725c&"
import script from "./TamanhoVal.vue?vue&type=script&lang=js&"
export * from "./TamanhoVal.vue?vue&type=script&lang=js&"
import style0 from "./TamanhoVal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports